import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import CheckboxGroup from '../../../exportacion_react_pdf/CheckboxGroup';
import QuestionResponse from '../../../exportacion_react_pdf/QuestionResponse';
import { Select } from 'antd';
import SelectGroup from '../../../exportacion_react_pdf/SelectGroup';


// Define el documento
const ExportPaso2 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
  <Text style={styles.title_1}>II. Información del Participante</Text>

  <QuestionResponse
    label={'¿Quién responde el cuestionario?:'}
    value={formData?.quien_responde ?? ''}
  />

  {formData?.quien_responde === 'Otro' && (
    <QuestionResponse
      label={'¿Cuál?:'}
      value={formData?.otro_quien_responde ?? ''}
    />
  )}

  {formData?.quien_responde === 'Delegado' && (
    <CheckboxGroup
      label='¿Presenta el documento pertinente y diligenciado en su totalidad?'
      selectedValue={formData?.delegado_presenta_documento_pertinente ?? ''}
    />
  )}

  <QuestionResponse
    label={'¿Nombre Persona que responde la encuesta?:'}
    value={formData?.nombre_persona ?? ''}
  />

  <QuestionResponse
    label={'¿Nombre identitario: (En caso de ser diferente al nombre en su documento de identidad)?:'}
    value={formData?.nombre_identitario ?? ''}
  />

  <CheckboxGroup
    label='¿Rango de edad?:'
    selectedValue={formData?.rango_edad ?? ''}
    options={["14 a 28", "29-59", "60 años en adelante"]}
  />

  <CheckboxGroup
    label='¿Género?:'
    selectedValue={formData?.genero ?? ''}
    options={["Masculino", "Femenino", "Persona no binaria", "No deseo especificar"]}
  />

  {(formData?.genero === 'Femenino' || formData?.genero === 'Persona no binaria') && (
    <CheckboxGroup
      label='¿Actualmente se encuentra en estado de embarazo?'
      selectedValue={formData?.estado_embarazo ?? ''}
    />
  )}

  <QuestionResponse
    label='Nivel de escolaridad:'
    value={formData?.nivel_escolaridad ?? ''}
  />

  <QuestionResponse
    label='Grupo étnico al que pertenece:'
    value={formData?.grupo_etnico ?? ''}
  />

  {formData?.grupo_etnico === 'Indígena' && (
    <>
      <CheckboxGroup
        label='Su lengua nativa es español?'
        selectedValue={formData?.lengua_nativa ?? ''}
      />
      {formData?.lengua_nativa === 'No' && (
        <QuestionResponse
          label='¿Cuál es su lengua nativa?:'
          value={formData?.lengua_nativa_no ?? ''}
        />
      )}
    </>
  )}

  <CheckboxGroup
    label='¿Es una persona en condición de discapacidad?'
    selectedValue={formData?.discapacidad ?? ''}
  />

  {formData?.discapacidad === 'Sí' && (
    <QuestionResponse
      label='¿Especificar qué tipo de discapacidad?'
      value={formData?.tipo_discapacidad ?? ''}
    />
  )}

  <QuestionResponse
    label='¿Con qué habilidades lectoescritoras cuenta?'
    value={formData?.habilidades_lectoescritoras ?? ''}
  />

  <CheckboxGroup
    label='Requiere traductor y/o acompañante'
    selectedValue={formData?.traductor_acompanante ?? ''}
  />

  <CheckboxGroup
    label='¿Cuenta con afiliación a:'
    selectedValue={formData?.afiliacion ?? ''}
    options={["Salud", "Pensión", "Ninguna"]}
  />

  <SelectGroup
    label='¿Con quién convive actualmente?'
    selectedValue={
     formData?.convive_actualmente ?? []
    }
  />

  {(formData?.convive_actualmente ?? []).includes('Otro') && (
    <QuestionResponse
      label={'¿Con quién más convive actualmente?:'}
      value={formData?.otro_convive_actualmente ?? ''}
    />
  )}

  <QuestionResponse
    label='¿Cuántas horas diarias dedica a actividades de cuidado (cuidado de niños, personas mayores, tareas domésticas, etc.)?'
    value={formData?.horas_actividad_cuidado ?? ''}
  />

  <CheckboxGroup
    label='¿Vive en el mismo predio donde funciona el emprendimiento?'
    selectedValue={formData?.vive_mismo_lugar_emprendimiento ?? ''}
  />
</View>


    </>
);

export default ExportPaso2;